import React from 'react';
import { getRefinedDeliveryOversea } from '../../../app/Helper/DeliveryHelper';

/**
 * 해외 직배송, 해외 구매대행 컴포넌트
 */
function DeliveryOversea() {
  const { isPurchaseAvailable, htDealInfo } = TMON.htStaticData;

  const refinedData = getRefinedDeliveryOversea(htDealInfo);

  if (!refinedData) {
    return null;
  }

  const { fixedText } = refinedData;

  return isPurchaseAvailable && fixedText && <div>{fixedText}</div>;
}

export default DeliveryOversea;
